import { Grid, Typography } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getAllFocus } from "../../services";
import { getActiveLearningPath } from "../../shared/slices/activeLearningPath";
import { LearningPathCard } from "../learning-path-card";
import { useStyles } from "./learning-path-cards.styles";

export const LearningPathCards = () => {
  const classes = useStyles();
  const currentLearningPathId = useSelector(getActiveLearningPath);
  const { data: focuses } = useQuery(["focus/all"], getAllFocus);

  return (
    <Grid container direction="column" id="learning-wt-7">
      <Typography className={classes.title} data-testid="title">
        Checkout another learning path
      </Typography>
      <div className={classes.learningPaths}>
        {focuses
          ?.map((focus) => focus.learningPaths[0])
          .filter((lp) => lp.id != currentLearningPathId)
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((lp, index) => (
            <LearningPathCard key={lp.id} image={index + 1} learningPath={lp} />
          ))}
      </div>
    </Grid>
  );
};
